import React from 'react';
import ReactPlayer from 'react-player';
import { useDispatch } from 'react-redux';
import { useChip } from 'src/components/chip/ChipHook';
import {
  useParams,
  useHistory,
} from 'react-router-dom';
import { fetchNodeAssets } from 'src/features/nodes/nodesSlice';
import 'firebase/storage';
import Confetti from 'react-confetti';
/** type imports */
import type { AppDispatch } from 'src/app/store';
import type {
  PulleyNode,
  NodeState,
  Story,
} from 'types';
/** Selie specific styling */
import './index.css';




interface Props {
  seasonId: string;
  storyId: string;
  story: Story;
  nodeState: NodeState<PulleyNode>;
}
const Pulley: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { nodeId: urlNodeId } = useParams<{ nodeId: string }>();
  const [addJob] = useChip();
  const [playingKey, setPlayingKey] = React.useState<'startingVideo' | 'waitingVideo' | 'afterVideo'>('startingVideo');
  const history = useHistory();
  const { nodeState, seasonId, storyId, story } = props;
  const { nodeId, node, nodeWithAssets } = nodeState;
  const active = nodeId === urlNodeId;

  React.useEffect(() => {
    if (nodeWithAssets === null) {
      dispatch(fetchNodeAssets({ seasonId, storyId, nodeId, node }));
    }
  }, [dispatch, nodeWithAssets, seasonId, storyId, nodeId, node]);
  React.useEffect(() => {
    if (nodeWithAssets) {
      if (playingKey === 'waitingVideo') {
        const questionAudio = nodeWithAssets.botAudio;
        if (questionAudio) {
          console.log(questionAudio);
          addJob({
            audioClip: questionAudio,
          });
        }
      }
    }
  }, [addJob, playingKey, nodeWithAssets]);

  let nextNodeId: string | null = null;
  if (!node.isEndingNode) {
    const filteredEdgeArray = Object.entries(node.edges).filter(([, { targetNodeId }]) => !story.nodes[targetNodeId].isDeleted);
    if (filteredEdgeArray.length > 0) {
      const [[, { targetNodeId }]] = filteredEdgeArray;
      nextNodeId = targetNodeId;
    }
  }
  if (!nodeWithAssets) {
    return <div>Loading....</div>;
  }

  const players: { [key: string]: JSX.Element } = {
    startingVideo: <ReactPlayer
      playing={'startingVideo' === playingKey && active}
      url={nodeWithAssets.startingVideo}
      width={'100%'}
      height={'auto'}
      onEnded={() => setPlayingKey('waitingVideo')}
    />,
    waitingVideo: <ReactPlayer
      playing={'waitingVideo' === playingKey && active}
      url={nodeWithAssets.waitingVideo}
      width={'100%'}
      height={'auto'}
      loop={true}
    />,
    afterVideo: <ReactPlayer
      playing={'afterVideo' === playingKey && active}
      url={nodeWithAssets.afterVideo}
      width={'100%'}
      height={'auto'}
      onEnded={() => {
        if (nextNodeId) {
          const nextNodeUrl = `/seasons/${seasonId}/stories/${storyId}/nodes/${nextNodeId}`;
          console.log(nextNodeUrl);
          history.replace(nextNodeUrl);
        }
      }}
    />,
  };

  let nodeContainerHidden = 'hidden';
  if (active) {
    nodeContainerHidden = '';
  }

  const pullyStyles: React.CSSProperties = {
    backgroundImage: 'url(/pulley-image.png)',
    backgroundColor: 'white',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
  };
  if (playingKey !== 'waitingVideo') {
    pullyStyles.display = 'none';
  }
  return (
    <div className={`node-container ${nodeContainerHidden}`}>
      {Object.entries(players).map(([key, player]) => {
        let videoContainerHidden = 'hidden';
        if (playingKey === key) {
          videoContainerHidden = '';
        }
        return (
          <div
            className={`node-video-container ${videoContainerHidden}`}
            key={key}
          >
            {player}
          </div>
        );
      })}
      {playingKey === 'afterVideo' && <Confetti />}
      <div className='node-interaction-panel'>
        <div
          className={`option-item pulley-option`}
          style={pullyStyles}
          onClick={() => {
            setPlayingKey('afterVideo');
          }}
        ></div>
      </div>
    </div>
  );
};

export default Pulley;